import axios from '../../../axios'

// 获取列表
export const list = (data) => {
  return axios({
    url: '/basic/location/list',
    method: 'post',
    data
  })
}

// 查看
export const view = (data) => {
  return axios({
    url: '/basic/location/view',
    method: 'post',
    data
  })
}
// 查看
export const edit = (data) => {
  return axios({
    url: '/basic/location/edit',
    method: 'post',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: '/basic/location/save',
    method: 'post',
    data
  })
}
// 删除
export const doDelete = (data) => {
  return axios({
    url: '/basic/location/delete',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/basic/location.js